var AppTelemetryEventNames = /* @__PURE__ */ ((AppTelemetryEventNames2) => {
  AppTelemetryEventNames2["App_Page_hidden"] = "App_Page_hidden";
  AppTelemetryEventNames2["App_Page_visible"] = "App_Page_visible";
  AppTelemetryEventNames2["App_Page_close"] = "App_Page_close";
  AppTelemetryEventNames2["App_Init_Set_Experience"] = "App_Init_Set_Experience";
  AppTelemetryEventNames2["App_Init_GetRootWorkspace_RedirectToOnboarding"] = "App_Init_GetRootWorkspace_RedirectToOnboarding";
  AppTelemetryEventNames2["App_Init_GetRootWorkspace_Do_Not_Redirect_To_Onboarding"] = "Do_Not_Redirect_To_Onboarding";
  AppTelemetryEventNames2["App_Init_GetExperimentationGroup_Failed"] = "App_Init_GetExperimentationGroup_Failed";
  AppTelemetryEventNames2["App_Init_GetExperimentationGroup_Do_Not_Redirect_To_Onboarding"] = "App_Init_GetExperimentationGroup_Do_Not_Redirect_To_Onboarding";
  AppTelemetryEventNames2["App_Init_GetExperimentationGroup_RedirectToOnboarding"] = "App_Init_GetExperimentationGroup_RedirectToOnboarding";
  AppTelemetryEventNames2["App_SomethingWentWrong"] = "App_SomethingWentWrong";
  AppTelemetryEventNames2["App_UnknownError"] = "App_UnknownError";
  AppTelemetryEventNames2["Workspace_Mismatch"] = "Workspace_Mismatch";
  AppTelemetryEventNames2["Workspace_Mismatch_redirect"] = "Workspace_Mismatch_redirect";
  return AppTelemetryEventNames2;
})(AppTelemetryEventNames || {});
export {
  AppTelemetryEventNames
};
//# sourceMappingURL=AppTelemetryEventNames.js.map
